const CreateLineItem = async (job_id, description, amount, handleDone) => {
    let data = {
        job_id: job_id,
        description: description, 
        price: amount,
    };
    var requestOptions = {
        method: 'POST',
        redirect: 'follow',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
      };
    var response = await fetch(`${process.env.REACT_APP_BACKEND_ENDPOINT}/createLineItem?`, requestOptions)

    let result = await response.json();
    handleDone(result);
    return result;
}

export default CreateLineItem;